import { ref, onMounted, onUnmounted } from 'vue'

export function useDeviceDetection() {
    const isMobile = ref(false)
    const isTablet = ref(false)
    const isDesktop = ref(false)

    const checkDevice = () => {
        const width = window.innerWidth

        // Define breakpoints
        const mobileBreakpoint = 769
        const tabletBreakpoint = 1025

        isMobile.value = width < mobileBreakpoint
        isTablet.value = width >= mobileBreakpoint && width < tabletBreakpoint
        isDesktop.value = width >= tabletBreakpoint
    }

    onMounted(() => {
        checkDevice()
        window.addEventListener('resize', checkDevice)
    })

    onUnmounted(() => {
        window.removeEventListener('resize', checkDevice)
    })

    return {
        isMobile,
        isTablet,
        isDesktop
    }
}